import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { formService } from '../../../services/formServices'; // Adjust path as needed

import './Newsletter.scss';

const Newsletter = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert('Please enter a valid email address');
            return;
        }

        setIsSubmitting(true);

        try {
            await formService.subscribeNewsletter({
                email,
                source: 'website_footer' // or get from props if needed
            });

            setSuccess(true);
            setEmail('');

            // Reset success message after 3 seconds
            setTimeout(() => setSuccess(false), 3000);
        } catch (error) {
            console.error('Newsletter subscription error:', error);
            alert(error.response?.data?.message || 'Subscription failed. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className="newsletter-section">
            <div className="newsletter-container">
                <motion.div
                    className="newsletter-box"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <motion.h2
                        className="newsletter-heading"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        SUBSCRIBE TO OUR NEWSLETTER
                    </motion.h2>

                    <motion.p
                        className="newsletter-subheading"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        Stay updated with our latest news and offers
                    </motion.p>

                    <motion.form
                        className="newsletter-form"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        onSubmit={handleSubmit}
                    >
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email address"
                            className="newsletter-input"
                            required
                            disabled={isSubmitting}
                        />
                        <button
                            type="submit"
                            className="newsletter-button"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                        </button>
                    </motion.form>

                    {success && (
                        <motion.p
                            className="success-message"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                        >
                            ✓ Successfully subscribed!
                        </motion.p>
                    )}

                    <motion.p
                        className="newsletter-small-text"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        We respect your privacy and will never share your information
                    </motion.p>
                </motion.div>
            </div>
        </section>
    );
};

export default Newsletter;